import BrandmisuseService from '../services/brandmisuse-service';

export const brandmisuse = {
  namespaced: true,
  state: {
    project: null,
    brandmisuse: null,
  },
  actions: {
    initBrandmisuse({ commit }, brandmisuse) {
      commit('setBrandmisuse', brandmisuse);
    },
    getByProjectReference({ commit }, projectReference) {
      return BrandmisuseService.getByProjectReference(projectReference);
    },
    getByLodgementCertificateNumber({ commit }, lodgementCertificateNumber) {
      return BrandmisuseService.getByLodgementCertificateNumber(lodgementCertificateNumber);
    },
    getByUMR({ commit }, umr) {
      return BrandmisuseService.getByUMR(umr);
    },
    getProject({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      commit('setProject', []);
      return BrandmisuseService.getProject(id)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setProject', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    authorise({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseService.authorise(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    create({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseService.create(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBrandmisuse', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    update({ commit, dispatch }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseService.update(payload)
        .then(async (result) => {
          await new Promise(resolve => setTimeout(resolve, 6000));
          const response = await dispatch('brandmisuseSearch/getBrandmisuseFollowUpDateCount', {}, { root: true })
          commit('brandmisuseSearch/setBrandmisuseFollowUpDateCount', response.brandMisuseFollowUpDateCount, { root: true });
          commit('setIsBusy', false, { root: true });
          commit('setBrandmisuse', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    delete({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseService.delete(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    get({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseService.get(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBrandmisuse', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    clearBrandmisuse({ commit }) {
      commit('setBrandmisuse', null);
    },
    updateTradingStandards({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseService.updateTradingStandards(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBrandmisuse', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    deleteBrandmisuseFollowUpDate({ commit, dispatch }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseService.deleteBrandmisuseFollowUpDate(payload)
        .then(async (result) => {
          await new Promise(resolve => setTimeout(resolve, 3000));
          const response = await dispatch('brandmisuseSearch/getBrandmisuseFollowUpDateCount', {}, { root: true })
          commit('brandmisuseSearch/setBrandmisuseFollowUpDateCount', response.brandMisuseFollowUpDateCount, { root: true });
          commit('setIsBusy', false, { root: true });
          commit('setBrandmisuseFollowUpDateDeleted', true);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setProject(state, newState) {
      state.project = newState;
    },
    setBrandmisuse(state, newState) {
      state.brandmisuse = newState;
    },
    setBrandmisuseFollowUpDateDeleted(state, newState) {
      state.brandmisuse.followUpDateDeleted = newState;
      if (newState === true) {
        state.brandmisuse.followUpDate = null;
      }
    },
  },
};
